// Tag for graphql format
const gql = String.raw;

export interface IFranchiseGroupItem {
	franchiseName: string;
}

const FranchiseGroupItemFragment = gql`
	fragment FranchiseGroupItem on FranchiseGroupItem {
		franchiseName
	}
`;
export interface ILocationFranchise {
	_id: string;
	franchise: string;
	dealerCode: string;
	groups: IFranchiseGroupItem[];
	isCombined: boolean;
	area: string;
}

const LocationFranchiseFragment = gql`
	fragment LocationFranchise on LocationFranchise {
		_id
		franchise
		dealerCode
		groups {
			...FranchiseGroupItem
		}
		isCombined
		area
	}
	${FranchiseGroupItemFragment}
`;

const LocationOEMsFragment = gql`
	fragment LocationOEMs on LocationOEMs {
		_id
		oemName
		oemShort
		oemReference
		dealerCodeFS
		version
		dba
		legalName
		financialStatementVersion
		franchises {
			...LocationFranchise
		}
	}
	${LocationFranchiseFragment}
`;

const GeoDetailsFragment = gql`
	fragment GeoDetails on GeoDetails {
		address
		address2
		city
		state
		zipCode
		countryCode
		country
	}
`;

export { LocationOEMsFragment, LocationFranchiseFragment, GeoDetailsFragment };
